import React, { useState } from 'react';
import { supabase } from '../../services/supabaseClient';
import { loginStyles as s } from '../../styles/loginStyles';

const ForgotPassword = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResetRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/change-password`,
    });

    if (error) alert(error.message);
    else setMessage('Revisa tu correo para el enlace de recuperación.');
    setLoading(false);
  };

  if (message) return <p className="text-[#00704a] text-sm font-bold">{message}</p>;

  return (
    <form onSubmit={handleResetRequest} className="space-y-6">
      <input type="email" className={s.inputField} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
      <div className="flex justify-between">
        <button type="button" onClick={onBack} className="text-xs text-gray-400">Volver</button>
        <button type="submit" disabled={loading} className={s.primaryButton}>Enviar Enlace</button>
      </div>
    </form>
  );
};

export default ForgotPassword;